export enum WebSocketMessageType {
    Message = 'Message',
    FolderLock = 'FolderLock',
    FolderAdd = 'FolderAdd',
    ConnectedUser = 'ConnectedUser',
    DisconnectedUser = 'DisconnectedUser',
    CreateRoom = 'CreateRoom',
    NewTchatMessage = 'NewTchatMessage',
    KillRoom = 'KillRoom',
    FolderDelete = 'FolderDelete',
    WorkflowProcessing = 'WorkflowProcessing',
    WorkflowProcessingError = 'WorkflowProcessingError',
    DocumentAdd = 'DocumentAdd',
    DocumentDelete = 'DocumentDelete',
    FolderHistoryChange = 'FolderHistoryChange',
    FolderUnlockRequest = 'FolderUnlockRequest',
    FolderUnlockResponse = 'FolderUnlockResponse',
    FolderClone = 'FolderClone',
    WorkflowStepActivation = 'WorkflowStepActivation',
    WorkflowStepCompletion = 'WorkflowStepCompletion',
    WorkflowStepStateModification = 'WorkflowStepStateModification',
    FolderMerge = 'FolderMerge',
    FolderMoveToBox = 'FolderMoveToBox',
    FolderReadStatusToggle = 'FolderReadStatusToggle',
    StandByStateToggle = 'StandByStateToggle',
    FolderAttributeModification = 'FolderAttributeModification',
    CommentsChange = 'CommentsChange',
    DocumentUpdate = 'DocumentUpdate',
    ForceDisconnection = 'ForceDisconnection',
    FolderArchiving = 'FolderArchiving',
    WaitingArchivingStateToggle = 'WaitingArchivingStateToggle',
    DraftEmailCreation = 'DraftEmailCreation',
}
